import { Snackbar } from '@mui/material';
import * as React from 'react';

type PopupMessageProps = {
  message: string,
  action?: () => void
}

const PopupMessage: React.FC<PopupMessageProps> = ({ message, action }) => {
  const [open, setOpen] = React.useState(true)

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      style={{ zIndex: 1000, bottom: 100 }}
      open={open}
      autoHideDuration={6000}
      onClose={() => setOpen(false)}
      message={message}
      action={action}
    />
  )
}
export default PopupMessage